import calendarApi from '../../api/calendar-api'

const state = {
  configCalendar: {},
  myCalendar: {},
  calendar: {},
  holidays: [],
  calendars: [],
  totalCalendars: 0,
}

const mutations = {
  setConfigCalendar(state, val) {
    state.configCalendar = val
  },
  setCalendar(state, val) {
    state.calendar = val
  },
  setCalendars(state, val) {
    state.calendars = val
  },
  setTotalCalendars(state, val) {
    state.totalCalendars = val
  },
  setMyCalendar(state, val) {
    state.myCalendar = val
  },
  setHolidays(state, val) {
    state.holidays = val
  },
}

const actions = {
  async list({ commit }, filters) {
    commit('app/loading', true, { root: true })
    await calendarApi.list(filters).then(
      response => {
        commit('setCalendars', response.data.data || response.data)
        commit('setTotalCalendars', response.data.meta ? response.data.meta.total[1] : response.data.total || 0)
        commit('app/loading', false, { root: true })
      },
      () => {
        commit('app/loading', false, { root: true })
        commit('notifications', { title: 'Error al obtener el listado de calendarios.', variant: 'danger' }, { root: true })
        commit('setShowNotifications', true, { root: true })
      },
    )
  },
  async getCalendar({ commit }, { id, year = '' }) {
    commit('app/loading', true, { root: true })
    await calendarApi.getCalendar(id, year)
      .then(
        response => {
          commit('setCalendar', response.data.data)
          commit('app/loading', false, { root: true })
        },
        () => {
          commit('app/loading', false, { root: true })
          commit('notifications', { title: 'Error al obtener la información.', variant: 'danger' }, { root: true })
          commit('setShowNotifications', true, { root: true })
        },
      )
  },
  async getConfigCalendar({ commit }, id) {
    commit('app/loading', true, { root: true })
    await calendarApi.getConfigCalendar(id)
      .then(
        response => {
          commit('setConfigCalendar', response.data)
          commit('app/loading', false, { root: true })
        },
        () => {
          commit('app/loading', false, { root: true })
          commit('notifications', { title: 'Error al obtener la información.', variant: 'danger' }, { root: true })
          commit('setShowNotifications', true, { root: true })
        },
      )
  },
  async getMyCalendar({ commit }, year) {
    commit('app/loading', true, { root: true })
    await calendarApi.getMyCalendar(year)
      .then(
        response => {
          commit('setMyCalendar', response.data.data)
          commit('app/loading', false, { root: true })
        },
        () => {
          commit('app/loading', false, { root: true })
          commit('notifications', { title: 'Error al obtener el calendario.', variant: 'danger' }, { root: true })
          commit('setShowNotifications', true, { root: true })
        },
      )
  },
  async getHolidays({ commit }, {
    start_date, end_date, client_id, year,
  }) {
    commit('app/loading', true, { root: true })
    await calendarApi.holidays(start_date, end_date, client_id, year)
      .then(
        response => {
          // La respuesta contiene un array de calendarios con holidays dentro
          const allHolidays = []
          if (Array.isArray(response.data)) {
            response.data.forEach(calendar => {
              if (calendar.holidays && Array.isArray(calendar.holidays)) {
                calendar.holidays.forEach(holiday => {
                  // Agregar autonomous_community del calendario al holiday
                  allHolidays.push({
                    ...holiday,
                    autonomous_community: calendar.autonomous_community,
                  })
                })
              }
            })
          }
          commit('setHolidays', allHolidays)
          commit('app/loading', false, { root: true })
        },
        () => {
          commit('app/loading', false, { root: true })
          commit('notifications', { title: 'Error al obtener los festivos.', variant: 'danger' }, { root: true })
          commit('setShowNotifications', true, { root: true })
        },
      )
  },
  create({ commit }, data) {
    commit('app/loading', true, { root: true })
    return calendarApi.create(data)
      .then(
        () => {
          commit('notifications', { title: 'Calendario creado con éxito.', variant: 'success' }, { root: true })
          commit('setShowNotifications', true, { root: true })
          commit('app/loading', false, { root: true })
        },
        () => {
          commit('app/loading', false, { root: true })
          commit('notifications', { title: 'Error al crear el calendario.', variant: 'danger' }, { root: true })
          commit('setShowNotifications', true, { root: true })
        },
      )
  },
  addHoliday({ commit }, { id, data }) {
    commit('app/loading', true, { root: true })
    return calendarApi.addHoliday(id, data)
      .then(
        () => {
          commit('notifications', { title: 'Festivo añadido con éxito.', variant: 'success' }, { root: true })
          commit('setShowNotifications', true, { root: true })
          commit('app/loading', false, { root: true })
        },
        () => {
          commit('app/loading', false, { root: true })
          commit('notifications', { title: 'Error al añadir el festivo.', variant: 'danger' }, { root: true })
          commit('setShowNotifications', true, { root: true })
        },
      )
  },
  edit({ commit }, { calendar }) {
    commit('app/loading', true, { root: true })
    calendarApi.edit(calendar)
      .then(
        () => {
          commit('notifications', { title: 'Información actualizada con éxito.', variant: 'success' }, { root: true })
          commit('setShowNotifications', true, { root: true })
          commit('app/loading', false, { root: true })
        },
        () => {
          commit('app/loading', false, { root: true })
          commit('notifications', { title: 'Error al actualizar.', variant: 'danger' }, { root: true })
          commit('setShowNotifications', true, { root: true })
        },
      )
  },
  async update({ commit }, { id, data }) {
    commit('app/loading', true, { root: true })
    await calendarApi.update(id, data).then(
      () => {
        commit('notifications', { title: 'Calendario actualizado con éxito.', variant: 'success' }, { root: true })
        commit('setShowNotifications', true, { root: true })
        commit('app/loading', false, { root: true })
      },
      () => {
        commit('app/loading', false, { root: true })
        commit('notifications', { title: 'Error al actualizar el calendario.', variant: 'danger' }, { root: true })
        commit('setShowNotifications', true, { root: true })
      },
    )
  },
  delete({ commit }, id) {
    commit('app/loading', true, { root: true })
    calendarApi.delete(id).then(
      () => {
        commit(
          'notifications',
          { title: 'Calendario eliminado con éxito.', variant: 'success' },
          { root: true },
        )
        window.location.reload()
      },
      () => {
        commit('app/loading', false, { root: true })
        commit(
          'notifications',
          { title: 'Error al eliminar el calendario.', variant: 'danger' },
          { root: true },
        )
        commit('setShowNotifications', true, { root: true })
      },
    )
  },
  async deleteHoliday({ commit }, {
    id_calendar, id_holiday,
  }) {
    commit('app/loading', true, { root: true })
    await calendarApi.deleteHoliday(id_calendar, id_holiday)
      .then(
        () => {
          commit('notifications', { title: 'Festivo eliminado con éxito.', variant: 'success' }, { root: true })
          commit('setShowNotifications', true, { root: true })
          commit('app/loading', false, { root: true })
          window.location.reload()
        },
        () => {
          commit('app/loading', false, { root: true })
          commit('notifications', { title: 'Error al eliminar el festivo.', variant: 'danger' }, { root: true })
          commit('setShowNotifications', true, { root: true })
        },
      )
  },

}

const getters = {
  getConfigCalendar: state => state.configCalendar,
  getCalendar: state => state.calendar,
  getCalendars: state => state.calendars,
  getMyCalendar: state => state.myCalendar,
  getHolidays: state => state.holidays,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
